function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BlockTemplate = require('./block.template');
var _require = require('../explorer-format'),
  formatBlockForPage = _require.formatBlockForPage,
  normalizeBlockRecord = _require.normalizeBlockRecord;
var _require2 = require('../search-nav'),
  blockLookupArgument = _require2.blockLookupArgument,
  classifyBlockIdentifier = _require2.classifyBlockIdentifier;
var _require3 = require('../tx-actions'),
  collectP2shUnlockTargets = _require3.collectP2shUnlockTargets,
  exportTransaction = _require3.exportTransaction,
  unlockTransactionInRustscript = _require3.unlockTransactionInRustscript;
var Block = /*#__PURE__*/function () {
  function Block(app, mod, input) {
    var expandTxSignature = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, Block);
    this.app = app;
    this.mod = mod;
    this.blockInput = input;
    this.blockHash = input;
    this.block = null;
    this.loading = true;
    this.loadingMessage = 'Loading block…';
    this.error = null;
    this.expandedSignature = null;
    this.pendingExpandSignature = expandTxSignature || null;
    this.container = '.explorer-view';
    this.fetchToken = 0;
    this.fetchingTransactions = false;
    this.fetchTransactionsError = null;
  }
  return _createClass(Block, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.loading = true;
      this.loadingMessage = 'Loading block…';
      this.error = null;
      this.block = null;
      this.expandedSignature = null;
      this.fetchingTransactions = false;
      this.fetchTransactionsError = null;
      this.paint();
      this.attachEvents();
      this.loadBlock();
    }
  }, {
    key: "paint",
    value: function paint() {
      var error = this.error ? this.app.browser.escapeHTML(this.error) : null;
      var block = this.block ? formatBlockForPage(this.app, this.block) : null;
      var expandedSignature = this.expandedSignature || this.pendingExpandSignature;

      // A block only carries SPV placeholder transactions when it was read from
      // the browser's local lite chain. Offer to pull the full copy from the
      // Explorer peer whenever one is connected.
      var canFetchTransactions = !!(block !== null && block !== void 0 && block.hasSpvTransactions) && !!this.mod.explorerPeer;
      var fetchTransactionsError = this.fetchTransactionsError ? this.app.browser.escapeHTML(this.fetchTransactionsError) : null;
      this.app.browser.replaceElementContentBySelector(BlockTemplate({
        blockHash: this.app.browser.escapeHTML(this.blockHash),
        loading: this.loading,
        loadingMessage: this.app.browser.escapeHTML(this.loadingMessage),
        error: error,
        block: block,
        expandedSignature: expandedSignature,
        canFetchTransactions: canFetchTransactions,
        fetchingTransactions: this.fetchingTransactions,
        fetchTransactionsError: fetchTransactionsError
      }), this.container);
    }
  }, {
    key: "fetchFullTransactions",
    value: function () {
      var _fetchFullTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var peer, identifier, fullBlock, merged, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.fetchingTransactions) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              peer = this.mod.explorerPeer;
              if (peer) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              identifier = this.blockLookupKey();
              if (!(identifier == null)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              this.fetchingTransactions = true;
              this.fetchTransactionsError = null;
              this.paint();
              this.attachEvents();
              fullBlock = null;
              _context.p = 4;
              _context.n = 5;
              return this.mod.requestBlockFromPeerPromise(this.app, peer, identifier, true);
            case 5:
              fullBlock = _context.v;
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              fullBlock = null;
            case 7:
              if (!(this.mod.blockComponent !== this)) {
                _context.n = 8;
                break;
              }
              return _context.a(2);
            case 8:
              this.fetchingTransactions = false;
              if (fullBlock && Array.isArray(fullBlock.transactions)) {
                // Preserve the metadata already derived from the local block (burn fee,
                // difficulty, etc.) and only swap in the full transaction list so the
                // summary panel does not regress to placeholder values.
                merged = normalizeBlockRecord(this.block);
                if (merged && _typeof(merged) === 'object') {
                  merged.transactions = fullBlock.transactions;
                  this.block = merged;
                } else {
                  this.block = fullBlock;
                }
                // The previously expanded row was an SPV placeholder that no longer
                // exists in the full transaction list.
                this.expandedSignature = null;
              } else {
                this.fetchTransactionsError = 'Could not fetch transactions from the Explorer peer. Please try again.';
              }
              this.paint();
              this.attachEvents();
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[4, 6]]);
      }));
      function fetchFullTransactions() {
        return _fetchFullTransactions.apply(this, arguments);
      }
      return fetchFullTransactions;
    }()
  }, {
    key: "expandAndScrollToTransaction",
    value: function expandAndScrollToTransaction(signature) {
      if (!signature) {
        return;
      }
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var row = root.querySelector(".explorer-tx-row[data-tx-signature=\"".concat(CSS.escape(signature), "\"]"));
      if (!row) {
        return;
      }
      root.querySelectorAll('.explorer-tx-row.is-expanded').forEach(function (openRow) {
        if (openRow !== row) {
          openRow.classList.remove('is-expanded');
          var openTeaser = openRow.querySelector('.explorer-tx-teaser');
          if (openTeaser) {
            openTeaser.setAttribute('aria-expanded', 'false');
          }
        }
      });
      row.classList.add('is-expanded');
      var teaser = row.querySelector('.explorer-tx-teaser');
      if (teaser) {
        teaser.setAttribute('aria-expanded', 'true');
      }
      this.expandedSignature = signature;
      this.pendingExpandSignature = null;
      requestAnimationFrame(function () {
        row.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    }
  }, {
    key: "blockLookupKey",
    value: function blockLookupKey() {
      return blockLookupArgument(this.app, this.blockInput);
    }
  }, {
    key: "tryLocalBlock",
    value: function () {
      var _tryLocalBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$app, identifier, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.core) !== null && _this$app !== void 0 && (_this$app = _this$app.blockchain) !== null && _this$app !== void 0 && _this$app.getBlock) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, null);
            case 1:
              identifier = this.blockLookupKey();
              if (!(identifier == null)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, null);
            case 2:
              _context2.n = 3;
              return this.app.core.blockchain.getBlock(identifier, true);
            case 3:
              return _context2.a(2, _context2.v);
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              return _context2.a(2, null);
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function tryLocalBlock() {
        return _tryLocalBlock.apply(this, arguments);
      }
      return tryLocalBlock;
    }()
  }, {
    key: "tryPeerBlock",
    value: function () {
      var _tryPeerBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var peer, identifier;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              peer = this.mod.explorerPeer;
              if (peer) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, null);
            case 1:
              identifier = this.blockLookupKey();
              if (!(identifier == null)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, null);
            case 2:
              return _context3.a(2, this.mod.requestBlockFromPeerPromise(this.app, peer, identifier, true));
          }
        }, _callee3, this);
      }));
      function tryPeerBlock() {
        return _tryPeerBlock.apply(this, arguments);
      }
      return tryPeerBlock;
    }()
  }, {
    key: "tryCachedBlock",
    value: function () {
      var _tryCachedBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var classified, cached;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              classified = classifyBlockIdentifier(this.app, this.blockInput);
              if (classified) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, null);
            case 1:
              cached = (this.mod.blocks || []).find(function (block) {
                if (classified.type === 'block_id') {
                  return String(block === null || block === void 0 ? void 0 : block.id) === classified.value;
                }
                return (block === null || block === void 0 ? void 0 : block.hash) === classified.value;
              });
              if (cached) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, null);
            case 2:
              if (!(Array.isArray(cached.transactions) && cached.transactions.length)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, cached);
            case 3:
              return _context4.a(2, null);
          }
        }, _callee4, this);
      }));
      function tryCachedBlock() {
        return _tryCachedBlock.apply(this, arguments);
      }
      return tryCachedBlock;
    }()
  }, {
    key: "loadBlock",
    value: function () {
      var _loadBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var token, expandTarget, rawBlock, _rawBlock;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              token = ++this.fetchToken;
              expandTarget = this.pendingExpandSignature;
              _context5.n = 1;
              return this.tryLocalBlock();
            case 1:
              rawBlock = _context5.v;
              if (!(token !== this.fetchToken)) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              if (rawBlock) {
                _context5.n = 4;
                break;
              }
              _context5.n = 3;
              return this.tryCachedBlock();
            case 3:
              rawBlock = _context5.v;
            case 4:
              if (!(token !== this.fetchToken)) {
                _context5.n = 5;
                break;
              }
              return _context5.a(2);
            case 5:
              if (rawBlock) {
                _context5.n = 7;
                break;
              }
              this.loading = true;
              this.loadingMessage = 'Attempting to load block from network…';
              this.error = null;
              this.paint();
              _context5.n = 6;
              return this.tryPeerBlock();
            case 6:
              rawBlock = _context5.v;
            case 7:
              if (!(token !== this.fetchToken)) {
                _context5.n = 8;
                break;
              }
              return _context5.a(2);
            case 8:
              if (!rawBlock) {
                this.loading = false;
                this.error = 'Block not found on local chain or Explorer peer.';
                this.block = null;
                this.pendingExpandSignature = null;
              } else {
                this.block = rawBlock;
                this.loading = false;
                this.error = null;
                if ((_rawBlock = rawBlock) !== null && _rawBlock !== void 0 && _rawBlock.hash) {
                  this.blockHash = String(rawBlock.hash);
                }
                if (expandTarget) {
                  this.expandedSignature = expandTarget;
                }
              }
              this.paint();
              this.attachEvents();
              if (expandTarget && this.block) {
                this.expandAndScrollToTransaction(expandTarget);
              }
            case 9:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function loadBlock() {
        return _loadBlock.apply(this, arguments);
      }
      return loadBlock;
    }()
  }, {
    key: "findRawTransaction",
    value: function findRawTransaction(signature) {
      var _this$block;
      if (!signature || !((_this$block = this.block) !== null && _this$block !== void 0 && (_this$block = _this$block.transactions) !== null && _this$block !== void 0 && _this$block.length)) {
        return null;
      }
      for (var i = 0; i < this.block.transactions.length; i++) {
        var tx = this.block.transactions[i];
        var sig = (tx === null || tx === void 0 ? void 0 : tx.signature) || (tx === null || tx === void 0 ? void 0 : tx.hash) || '';
        if (sig === signature) {
          return tx;
        }
      }
      return null;
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      return this.app.browser.escapeHTML(String(text !== null && text !== void 0 ? text : ''));
    }
  }, {
    key: "pickP2shUnlockTarget",
    value: function pickP2shUnlockTarget(targets) {
      var _this = this;
      if (!(targets !== null && targets !== void 0 && targets.length)) {
        return Promise.resolve(null);
      }
      if (targets.length === 1) {
        return Promise.resolve(targets[0]);
      }
      return new Promise(function (resolve) {
        var _overlay$querySelecto, _overlay$querySelecto2;
        var overlay = document.createElement('div');
        overlay.className = 'explorer-tx-picker-overlay';
        overlay.innerHTML = "\n        <div class=\"explorer-tx-picker-dialog\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"explorer-tx-picker-title\">\n          <h3 class=\"explorer-tx-picker-title\" id=\"explorer-tx-picker-title\">Select P2SH slip to unlock</h3>\n          <div class=\"explorer-tx-picker-options\">\n            ".concat(targets.map(function (target, index) {
          return "\n              <button type=\"button\" class=\"explorer-tx-picker-option\" data-target-index=\"".concat(index, "\">\n                ").concat(_this.escapeHtml(target.label), "\n              </button>\n            ");
        }).join(''), "\n          </div>\n          <button type=\"button\" class=\"explorer-tx-picker-cancel\">Cancel</button>\n        </div>\n      ");
        var close = function close(value) {
          overlay.remove();
          document.removeEventListener('keydown', onKeyDown, true);
          resolve(value);
        };
        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            close(null);
          }
        };
        overlay.addEventListener('click', function (event) {
          if (event.target === overlay) {
            close(null);
          }
        });
        overlay.querySelectorAll('.explorer-tx-picker-option').forEach(function (btn) {
          btn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            var index = Number(btn.getAttribute('data-target-index'));
            close(Number.isFinite(index) ? targets[index] : null);
          });
        });
        (_overlay$querySelecto = overlay.querySelector('.explorer-tx-picker-cancel')) === null || _overlay$querySelecto === void 0 || _overlay$querySelecto.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          close(null);
        });
        document.body.appendChild(overlay);
        document.addEventListener('keydown', onKeyDown, true);
        (_overlay$querySelecto2 = overlay.querySelector('.explorer-tx-picker-option')) === null || _overlay$querySelecto2 === void 0 || _overlay$querySelecto2.focus();
      });
    }
  }, {
    key: "handleUnlockScript",
    value: function () {
      var _handleUnlockScript = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(signature) {
        var _this$block$id, _this$block2, _this$block3;
        var rawTx, targets, target;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              rawTx = this.findRawTransaction(signature);
              if (rawTx) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              targets = collectP2shUnlockTargets(rawTx);
              if (targets.length) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              _context6.n = 3;
              return this.pickP2shUnlockTarget(targets);
            case 3:
              target = _context6.v;
              if (target) {
                _context6.n = 4;
                break;
              }
              return _context6.a(2);
            case 4:
              unlockTransactionInRustscript(this.app, rawTx, target, {
                blk: this.block,
                block_id: (_this$block$id = (_this$block2 = this.block) === null || _this$block2 === void 0 ? void 0 : _this$block2.id) !== null && _this$block$id !== void 0 ? _this$block$id : (_this$block3 = this.block) === null || _this$block3 === void 0 ? void 0 : _this$block3.block_id
              });
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleUnlockScript(_x) {
        return _handleUnlockScript.apply(this, arguments);
      }
      return handleUnlockScript;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var backBtn = root.querySelector('[data-explorer-nav="home"]');
      if (backBtn) {
        backBtn.onclick = function (e) {
          e.preventDefault();
          _this2.mod.renderHome();
        };
      }
      root.querySelectorAll('.explorer-block-prev-link[data-block-hash]').forEach(function (link) {
        link.onclick = function (event) {
          event.preventDefault();
          event.stopPropagation();
          var hash = link.getAttribute('data-block-hash');
          if (hash) {
            _this2.mod.renderBlock(hash, {
              pushState: true,
              animate: true
            });
          }
        };
      });
      root.querySelectorAll('.explorer-block-fetch-txns').forEach(function (btn) {
        btn.onclick = function (event) {
          event.preventDefault();
          event.stopPropagation();
          _this2.fetchFullTransactions();
        };
      });
      root.querySelectorAll('.explorer-block-meta-toggle').forEach(function (toggle) {
        toggle.onclick = function (e) {
          var _toggle$closest;
          e.preventDefault();
          e.stopPropagation();
          var panel = (_toggle$closest = toggle.closest('.explorer-block-summary-panel')) === null || _toggle$closest === void 0 ? void 0 : _toggle$closest.querySelector('.explorer-block-detail-panel');
          if (!panel) {
            return;
          }
          var isOpen = panel.hidden;
          panel.hidden = !isOpen;
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          toggle.textContent = isOpen ? 'Hide full block metadata' : 'View full block metadata';
        };
      });
      root.querySelectorAll('.explorer-tx-row').forEach(function (row) {
        var teaser = row.querySelector('.explorer-tx-teaser');
        if (!teaser) {
          return;
        }
        var toggleRow = function toggleRow(e) {
          var _e$target;
          if (e !== null && e !== void 0 && (_e$target = e.target) !== null && _e$target !== void 0 && _e$target.closest('.explorer-action, .explorer-json-toggle, .explorer-link, .explorer-copy-btn')) {
            return;
          }
          if (e) {
            e.preventDefault();
          }
          var signature = row.getAttribute('data-tx-signature') || '';
          var isExpanded = row.classList.contains('is-expanded');
          root.querySelectorAll('.explorer-tx-row.is-expanded').forEach(function (openRow) {
            if (openRow !== row) {
              openRow.classList.remove('is-expanded');
              var btn = openRow.querySelector('.explorer-tx-teaser');
              if (btn) {
                btn.setAttribute('aria-expanded', 'false');
              }
            }
          });
          if (isExpanded) {
            row.classList.remove('is-expanded');
            teaser.setAttribute('aria-expanded', 'false');
            _this2.expandedSignature = null;
          } else {
            row.classList.add('is-expanded');
            teaser.setAttribute('aria-expanded', 'true');
            _this2.expandedSignature = signature;
          }
        };
        teaser.onclick = toggleRow;
        teaser.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleRow(e);
          }
        };
      });
      root.querySelectorAll('.explorer-json-toggle').forEach(function (toggle) {
        toggle.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          var node = toggle.closest('.explorer-json-node');
          if (!node) {
            return;
          }
          var isOpen = node.getAttribute('data-json-open') === 'true';
          node.setAttribute('data-json-open', isOpen ? 'false' : 'true');
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        };
      });
      root.querySelectorAll('.explorer-txmsg-toggle').forEach(function (toggle) {
        toggle.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          var section = toggle.closest('.explorer-txmsg-section');
          var payload = section === null || section === void 0 ? void 0 : section.querySelector('.explorer-txmsg-payload');
          if (!section || !payload) {
            return;
          }
          var isOpen = !section.classList.contains('is-open');
          section.classList.toggle('is-open', isOpen);
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          payload.hidden = !isOpen;
        };
      });
      root.querySelectorAll('[data-action="tx-export"]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var row = btn.closest('.explorer-tx-row');
          var signature = (row === null || row === void 0 ? void 0 : row.getAttribute('data-tx-signature')) || '';
          var rawTx = _this2.findRawTransaction(signature);
          if (!rawTx) {
            return;
          }
          try {
            var _this2$block$id, _this2$block, _this2$block2;
            exportTransaction(_this2.app, rawTx, {
              blk: _this2.block,
              block_id: (_this2$block$id = (_this2$block = _this2.block) === null || _this2$block === void 0 ? void 0 : _this2$block.id) !== null && _this2$block$id !== void 0 ? _this2$block$id : (_this2$block2 = _this2.block) === null || _this2$block2 === void 0 ? void 0 : _this2$block2.block_id
            });
          } catch (err) {
            console.warn('Explorer: export transaction failed', err);
          }
        });
      });
      root.querySelectorAll('[data-action="tx-unlock-script"]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var row = btn.closest('.explorer-tx-row');
          var signature = (row === null || row === void 0 ? void 0 : row.getAttribute('data-tx-signature')) || '';
          _this2.handleUnlockScript(signature);
        });
      });
    }
  }]);
}();
module.exports = Block;